import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";
import IngredientCategoryService from "../../services/ingredient/CategoryService";

export const IngredientCategoryContext = createContext("IngredientCategoryContext");

const IngredientCategoryContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [IngredientTotalElements, setIngredientTotalElements] = useState(0);
    const [ingredientCategoryList, setIngredientCategoryList] = useState([]);

    const getAllIngredientCategory = async params => {
        try {

            setLoading(true);

            const res = await IngredientCategoryService.getAllIngredientCategory(params);
            setIngredientCategoryList(res.data.content);
            setIngredientTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            // Toast("error", "Error", message);

        }
    }

    return (
        <IngredientCategoryContext.Provider
            value={{
                loading,
                IngredientTotalElements,
                ingredientCategoryList,
                getAllIngredientCategory,
            }}
        >
            {children}
        </IngredientCategoryContext.Provider>
    );
}

export default IngredientCategoryContextProvider;
